module.exports = __webpack_public_path__ + "static/media/pajero-1988nb.320096da.webp";